import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { invalidPhoneNumber } from "@notemeal/utils/phone-number";
import DialogTitle from "apps/web/src/componentLibrary/DialogTitle";
import React, { useState } from "react";
import AddPhoneNumberOrEmailDialog from "../../../../components/global/AddPhoneNumberOrEmailDialog";
import BinaryButton from "../../../../components/universal/BinaryButton";
import { AccountVerificationMethod } from "../../../../types";
import { invalidEmail } from "../../../../utils/invalidEmail";

interface EnableAccountModalProps {
  onClose: () => void;
  onEnable: (method: AccountVerificationMethod) => Promise<void>;
  open: boolean;
  athlete: { email: string | null; phoneNumber: string | null; id: string };
}

const EnableAccountModal = ({ onClose, open, onEnable, athlete }: EnableAccountModalProps) => {
  const [activationMethod, setActivationMethod] = useState<AccountVerificationMethod>("txt");

  const emailIsValid = () => {
    if (activationMethod === "email") {
      if (!athlete.email || invalidEmail(athlete.email)) {
        return false;
      }
    }
    return true;
  };
  const phoneIsValid = () => {
    if (activationMethod === "txt") {
      if (!athlete.phoneNumber || invalidPhoneNumber(athlete.phoneNumber)) {
        return false;
      }
    }
    return true;
  };
  const [activationStatus, setActivationStatus] = useState<null | "saving" | "done">(null);
  const handleEnable = () => {
    setActivationStatus("saving");
    if ((emailIsValid() && activationMethod === "email") || (phoneIsValid() && activationMethod === "txt")) {
      onEnable(activationMethod);
      onClose();
    }
  };
  const handleEnableWithoutValidation = () => {
    // This only gets called via the `onAdd()` callback in AddPhoneNumberOrEmailDialog
    // so we invariantly have a valid email/phone saved in the DB
    onEnable(activationMethod);
    onClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={open}
      onClose={onClose}>
      <DialogTitle title="Enable Mobile App" onClose={onClose} />
      <DialogContent>
        <Typography variant="body2Medium">Send account activation link via:</Typography>
        <BinaryButton
          size="xs"
          onLeftClick={() => setActivationMethod("email")}
          onRightClick={() => setActivationMethod("txt")}
          leftLabel="email"
          rightLabel="txt"
          initialLeftOrRight={activationMethod === "email" ? "left" : "right"}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleEnable}>Send</Button>
        {!emailIsValid() && activationStatus === "saving" && (
          <AddPhoneNumberOrEmailDialog
            open={!emailIsValid() && activationStatus === "saving"}
            onClose={() => setActivationStatus(null)}
            onAdd={handleEnableWithoutValidation}
            athleteId={athlete.id}
            type="email"
          />
        )}
        {!phoneIsValid() && activationStatus === "saving" && (
          <AddPhoneNumberOrEmailDialog
            open={!phoneIsValid() && activationStatus === "saving"}
            onClose={() => setActivationStatus(null)}
            onAdd={handleEnableWithoutValidation}
            athleteId={athlete.id}
            type="phoneNumber"
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default EnableAccountModal;
